import { requestGet } from '@/utils/request';

const api = {
    PROVINCE_LIST: 'system/area_province_list',
    CITY_LIST: 'system/area_city_list'
}

export async function areaProvinceList() {
    return requestGet(api.PROVINCE_LIST);
}

export async function areaCityList(pid) {
    let params = {pid: pid};
    return requestGet(api.CITY_LIST, params);
}